import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';


/**
 * wizStyleClass set style for the first children component
 * The objective is to avoid the creation of style attribute
 * This directive is the equivalent of ngStyle for wiz-components
 *
 * Exemple
 * <wiz-label [wizLabel]="Hello" [wizStyle]="{ 'background-color': 'red', 'color':'white'}"></wiz-label>
 */
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[wizStyle]',
})
export class WizStyleDirective implements OnInit {
  /*style property*/
  @Input() wizStyle: object;

  constructor(private elementRef: ElementRef, private  renderer: Renderer2) {
  }

  ngOnInit(): void {

    // Add styles on first children
    for (const [key, value] of Object.entries(this.wizStyle)) {
      this.renderer.setStyle(this.elementRef.nativeElement.children[0], key, value);
    }
  }
}
